// @ts-nocheck
import { ProductDetailsCanScrollPrevParameter } from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = ProductDetailsCanScrollPrevParameter;
type HandlerType = Handler<Parameter>;

export const dispatchSetCanScrollPrev: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ProductDetails/CanScrollPrev",
        parameter: props.parameter,
    });
};

export const chain = [dispatchSetCanScrollPrev];

const setCanScrollPrev = createHandlerChainRunner(chain, "SetCanScrollPrev");
export default setCanScrollPrev;
